// extracted by mini-css-extract-plugin
export default {"grid":"OrdersGrid_grid__85Zmk"};